import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

interface TextInputProps {
    value: string;
    onChange: (value: string) => void;
    onBlur?: () => void;
    id?: string;
    placeholder?: string;
    disabled?: boolean;
    fullWidth?: boolean;
    error?: string;
    color?: 'white' | 'default';
}

export function TextInput({
    value,
    onChange,
    onBlur,
    id,
    placeholder,
    disabled,
    fullWidth,
    error,
    color = 'default',
}: TextInputProps) {
    return (
        <Wrapper fullWidth={fullWidth}>
            <StyledInput
                id={id}
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onBlur={onBlur}
                placeholder={placeholder}
                disabled={disabled}
                fullWidth={fullWidth}
                color={color}
                hasError={!!error}
            />
            {error && <ErrorMessage>{error}</ErrorMessage>}
        </Wrapper>
    );
}

const Wrapper = styled('div')<{ fullWidth?: boolean }>(({ fullWidth }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    width: fullWidth ? '100%' : 'auto',
}));

const ErrorMessage = styled('span')({
    fontSize: 12,
    color: Colors.error,
});

const StyledInput = styled('input')<{ fullWidth?: boolean; color?: 'white' | 'default'; hasError?: boolean }>(
    ({ fullWidth, color, hasError }) => ({
        width: fullWidth ? '100%' : 'auto',
        padding: '8px 10px',
        fontSize: 14,
        color: Colors.darkNavy,
        backgroundColor: color === 'white' ? Colors.white : Colors.faintGrey,
        border: `1px solid ${hasError ? Colors.error : Colors.lightGrey}`,
        borderRadius: 10,
        outline: 'none',
        boxSizing: 'border-box',
        '&:focus': {
            borderColor: hasError ? Colors.error : Colors.mediumGrey,
        },
        '&:disabled': {
            backgroundColor: Colors.fill,
            color: Colors.mediumGrey,
        },
        '&::placeholder': {
            color: Colors.lightGrey,
        },
    }),
);
